import { useMemo, useEffect } from 'react';

// material
import { experimentalStyled as styled } from '@material-ui/core/styles';

import NProgress from 'nprogress';

//
import Logo2 from '../assets/Loading6.gif';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function LoadingScreenType1({ ...other }) {
  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return (
    <RootStyle {...other}>
      <img src={Logo2} alt="loading..." />
    </RootStyle>
  );
}
